import React from "react";
import { IChat } from "../interfaces/chat";
import { db } from "../services/firebaes.service";
import { useBookingsList } from "./Booking";
export const ChatListContext = React.createContext<{
  chats: IChat[];
}>({
  chats: [],
});

interface Props {
  children?: JSX.Element;
}

export default function ChatListProvider(props: Props) {
  const [chats, setChats] = React.useState<IChat[]>([]);
  const { listUid } = useBookingsList();
  const addChat = React.useCallback(
    (chat: IChat) => {
      const aleadyChat = chats.find((c) => c.uid === chat.uid);
      if (aleadyChat) return;
      setChats([...chats, chat]);
    },
    [chats]
  );

  const modifiedChat = React.useCallback(
    (chat: IChat) => {
      const newChats = chats.map((c) => {
        if (c.uid === chat.uid) return chat;
        else return c;
      });
      setChats(newChats);
    },
    [chats]
  );

  const unsubscribe = React.useCallback(() => {
    let audio = new Audio("/message-sound.mp3");
    if (listUid.length === 0) return;

    const unsub = db
      .collection("chats")
      .orderBy("updateAt", "asc")
      .onSnapshot((snap) => {
        snap.docChanges().forEach((change) => {
          if (change.type === "added") {
            if (change.doc.data().uid.includes(listUid)) {
              addChat(change.doc.data() as IChat);
            }
          }
          if (change.type === "modified") {
            if (change.doc.data().uid.includes(listUid)) {
              addChat(change.doc.data() as IChat);
              const chat = change.doc.data() as IChat;
              modifiedChat(chat);
              if (chat.isRead === false) audio.play();
            }
          }
        });
      });
    return () => unsub();
  }, [addChat, modifiedChat, listUid]);

  React.useEffect(() => unsubscribe(), [unsubscribe]);

  return (
    <ChatListContext.Provider value={{ chats }}>
      {props.children}
    </ChatListContext.Provider>
  );
}

export const useChatList = () => React.useContext(ChatListContext);
